export class OrderedFail {

    public date: Date;
    public name: string;
    public total: number;
    public code: string;
    public message: string;
   
    constructor() {}
}